// @todo The name and placement in the ecosystem of this file is not right

import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

import IconWarningGrey from '/shared/images/icons/bp-warning-black.svg';
import IconWarningBlack from '/shared/images/icons/icon-warning-black-full.svg';
import IconPadlockBlack from '/business/shared/images/icons/bp-padlock-black.svg';

interface Props {
  $info?: boolean;
  $warning?: boolean;
  $topBorder?: boolean;
  $hasNoIcon?: boolean;
  $hasExtraBottomPadding?: boolean;
  $padlock?: boolean;
  $isContentCenteredVertically?: boolean;
  $hasGreyBorder?: boolean;
}

function infoStyle({ $info = false }: Props) {
  if ($info) {
    return css`
      border-color: ${Colours.redLight5};
      color: ${Colours.black};
    `;
  }
}
function warningStyle({ $warning = false }: Props) {
  if ($warning) {
    return css`
      color: ${Colours.blackDark1};
      border-color: ${Colours.redLight5};
      background: ${Colours.redLight8};

      &::before {
        background-image: url('${IconWarningBlack}');
      }
    `;
  }
}

function hasPadlock({ $padlock = false }: Props) {
  if ($padlock) {
    return css`
      &::before {
        background-image: url('${IconPadlockBlack}');
      }
    `;
  }
}

function topBorderStyle({ $topBorder = false }: Props) {
  if ($topBorder) {
    return css`
      border-left: none;
      border-top-width: 2px;
      border-top-style: solid;
      margin-bottom: 1rem;
    `;
  }
}

function hasNoIconStyle({ $hasNoIcon = false }: Props) {
  if ($hasNoIcon) {
    return css`
      &::before {
        background: none;
        margin-right: 0;
      }
    `;
  }
}

function hasExtraBottomPaddingStyle({ $hasExtraBottomPadding = false }: Props) {
  if ($hasExtraBottomPadding) {
    return css`
      padding-bottom: 2rem;
    `;
  }
}

function isContentCenteredVertically({ $isContentCenteredVertically = false }: Props) {
  if ($isContentCenteredVertically) {
    return css`
      align-items: center;
    `;
  }
}

function hasGreyBorder({ $hasGreyBorder = false }: Props) {
  if ($hasGreyBorder) {
    return css`
      border-color: ${Colours.greyLight8};
    `;
  }
}

export default styled.div<Props>`
  color: ${Colours.black};
  padding: 1rem 2rem 1rem 1rem;
  border-left: 4px solid transparent;
  border-color: ${Colours.lime};
  background: ${Colours.whiteDark1};
  display: flex;
  margin-bottom: 2rem;
  width: 100%;

  &::before {
    content: '';
    flex-shrink: 0;
    background: url('${IconWarningGrey}') center center no-repeat;
    height: 1.4rem;
    width: 1.6rem;
    margin-right: 1rem;
  }

  > div {
    flex: 1;
    line-height: 1.7125;
    font-size: 0.9333rem;
    font-weight: normal;
    white-space: normal;

    strong {
      font-weight: 500;
    }
  }
  ${infoStyle}
  ${warningStyle}
  ${topBorderStyle}
  ${hasNoIconStyle}
  ${hasExtraBottomPaddingStyle}
  ${hasPadlock}
  ${isContentCenteredVertically}
  ${hasGreyBorder}
`;
